import React from 'react'
import Invoice from '../features/order/Components/Invoice'

const InvoicePages = () => {
  document.title = "Invoice - Plant Seller";
  return (
    <Invoice />
  )
}

export default InvoicePages
